<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row mb-3">
        <div class="col-md-12">
          <label>{{ $t('wholesaleReceipt.customer') }}</label>
          <a-select
            v-model="model.customer_id"
            :options="customerList"
            class="ts-w-full"
            @change="onCustomerChange"
            showSearch
            :filterOption="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            :placeholder="$t('select')"
          ></a-select>
        </div>
      </div>
      <div
        class="widget-todolist rounded"
        style="max-height: 400px; overflow-y: auto;"
        v-if="receipt_lists.length > 0"
      >
        <div class="widget-todolist-header">
          <h4 class="widget-todolist-header-title">
            {{ $t('wholesaleReceipt.receiptList') }}
          </h4>
        </div>
        <div
          class="widget-todolist-body rounded"
          v-for="(item, index) in receipt_lists"
          :key="index"
        >
          <div class="widget-todolist-item">
            <div>
              <div class="widget-todolist-input">
                {{ $t('wholesaleReceipt.invoiceNo') }}
              </div>
              <div class="widget-todolist-content">
                <h6 class="mb-0">{{ item.invoice_no }}</h6>
              </div>
            </div>
            <div>
              <div class="widget-todolist-input">
                {{ $t('wholesaleReceipt.invoiceAmount') }}
              </div>
              <div class="widget-todolist-content">
                <h6 class="mb-0">
                  <ts-display-currency
                    :amount="item.invoice_amount"
                    :currency_id="currency_id"
                  />
                </h6>
              </div>
            </div>
            <div>
              <div class="widget-todolist-input">
                {{ $t('wholesaleReceipt.amountReceived') }}
              </div>
              <div class="widget-todolist-content">
                <h6 class="mb-0">
                  <ts-display-currency
                    :amount="item.amount_received"
                    :currency_id="currency_id"
                  />
                </h6>
              </div>
            </div>
            <div>
              <div class="widget-todolist-input">
                {{ $t('wholesaleReceipt.receiptNo') }}
              </div>
              <div class="widget-todolist-content">
                <h6 class="mb-0">{{ item.receipt_no }}</h6>
              </div>
            </div>
            <div>
              <div class="widget-todolist-input">
                {{ $t('wholesaleReceipt.lastReceiptDate') }}
              </div>
              <div class="widget-todolist-content">
                <h6 class="mb-0">{{ item.payment_date }}</h6>
              </div>
            </div>
            <div>
              <div class="widget-todolist-input">
                {{ $t('wholesaleReceipt.lastAmountPaid') }}
              </div>
              <div class="widget-todolist-content">
                <h6 class="mb-0">
                  <ts-display-currency
                    :amount="item.amount_paid"
                    :currency_id="currency_id"
                  />
                </h6>
              </div>
            </div>
            <div>
              <div class="widget-todolist-input">
                {{ $t('wholesaleReceipt.amountDue') }}
              </div>
              <div class="widget-todolist-content">
                <h6 class="mb-0">
                  <ts-display-currency
                    class="text-danger"
                    :amount="item.amount_due"
                    :currency_id="currency_id"
                  />
                </h6>
              </div>
            </div>
            <div class="widget-todolist-icon">
              <Poptip
                confirm
                :title="$t('areYouSure')"
                @on-ok="sendRequest(item)"
                :transfer="true"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                ><ts-button
                  size="sm"
                  color="warning"
                  :waiting="item.is_sending"
                  :disabeld="item.is_sending"
                  >{{ $t('wholesaleReceipt.sendRequest') }}</ts-button
                >
              </Poptip>
            </div>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'

export default {
  props: ['value', 'validate', 'confirm_type'],
  name: 'customer-loan-request',
  data() {
    return {
      model: {
        stock_out_id: null,
        customer_id: undefined,
        request_amount: null,
        customer_name: null,
        invoice_no: null,
        currency_id: null
      },
      receipt_lists: [],
      errors: new Errors(),
      loading: false,
      customers: []
    }
  },
  computed: {
    customerList() {
      if (this.customers) {
        return this.customers.map(el => ({
          value: el.customer_id,
          label: el.customer_name + '|' + el.contact_number
        }))
      }
      return []
    },
    currency_id() {
      return this.$store.state.authUser.sys_setting.default_currency_id
    }
  },
  created() {
    this.getCustomerAllowLoanRequest()
  },
  methods: {
    ...mapActions('wholesale/receipt', ['getFormViewData', 'onLoanRequest']),
    getCustomerAllowLoanRequest() {
      this.loading = true
      this.getFormViewData({
        params: {
          fnName: 'customerAllowLoanRequest'
        }
      }).then(response => {
        this.loading = false
        this.customers = response.data.customerAllowLoanRequest
      })
    },
    getReceiptList() {
      if (this.model.customer_id) {
        this.loading = true
        this.$store
          .dispatch('wholesale/receipt/getReceiptList', this.model.customer_id)
          .then(response => {
            this.receipt_lists = response.data
          })
          .catch(error => {
            this.$toasted.error(error.message)
            this.errors = new Errors(error.errors)
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.model.receipt_lists = []
      }
    },
    sendRequest(item) {
      let serial = null
      if (
        item.wholesale_stock_out &&
        item.wholesale_stock_out.details &&
        item.wholesale_stock_out.details[0] &&
        item.wholesale_stock_out.details[0].serial_list &&
        item.wholesale_stock_out.details[0].serial_list[0]
      ) {
        serial = item.wholesale_stock_out.details[0].serial_list[0]
      }

      item.is_sending = true
      this.onLoanRequest({
        ref_stock_out_or_receipt_id: item.receipt_id,
        customer_id: item.customer_id,
        request_amount: item.amount_due,
        customer_name: item.customer_name,
        ref_invoice_or_receipt_no: item.receipt_no,
        currency_id: this.currency_id,
        request_source: 'Receipt',
        color: serial ? serial.color : null,
        plate_number: serial ? serial.plate_number : null,
        imei: serial ? serial.imei : null,
        engine_number: serial ? serial.engine_number : null,
        vehicle_registration_date: serial
          ? serial.vehicle_registration_date
          : null,
        issued_by: serial ? serial.issued_by : null
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
          this.$emit('fetchData')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (item.is_sending = false))
    },
    onCustomerChange() {
      this.model.receipt_lists = []
      this.errors = new Errors()
      this.getReceiptList()
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
<style lang="css" scoped>
.widget-todolist .widget-todolist-body {
  border: 1px solid #e4e7ea;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);
}
.widget-todolist .widget-todolist-item .widget-todolist-input {
  display: table-cell;
  padding: 4px 6px;
  vertical-align: middle;
  width: 160px;
  text-align: left;
}
.widget-todolist .widget-todolist-item .widget-todolist-content {
  display: table-cell;
  padding: 4px 6px;
  vertical-align: middle;
}
</style>
